(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    function revealSoldOutImages() {
  if (window.innerWidth > 749) return; // mobile only
  document.querySelectorAll('.featured-collection .product-card img').forEach(img => {
    img.style.display = 'block';
  });
  document.querySelectorAll('.featured-collection .product-card .sold-out-overlay, .product-card__placeholder-image').forEach(el => {
    el.style.display = 'none';
  });
}
window.addEventListener('load', function() {
  setTimeout(revealSoldOutImages, 500);
});
window.addEventListener('resize', revealSoldOutImages);
  } catch(e) { console.error(e); }
})();

})();
